<script lang="ts">
	import { classNames } from '../../lib/svelteHelper';

	interface Props {
		disabled?: boolean | undefined;
		primary?: boolean;
		overrideClass?: string | undefined;
		extraClass?: string | undefined;
		iconPlacement?: 'left' | 'right';
		title?: string | undefined;
		icon?: import('svelte').Snippet;
		children?: import('svelte').Snippet;
		onclick?: (event: MouseEvent) => void;
		[key: string]: any;
	}

	let {
		disabled = undefined,
		primary = false,
		overrideClass = undefined,
		extraClass = undefined,
		iconPlacement = 'left',
		title = undefined,
		icon,
		children,
		onclick,
		...rest
	}: Props = $props();
</script>

<button
	{onclick}
	type="button"
	disabled={disabled || null}
	{title}
	class={classNames(
		overrideClass === undefined
			? primary
				? 'bg-btn-primaryd hover:bg-btn-primaryh focus-visible:outline-btn-primaryh inline-flex cursor-default items-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:bg-gray-400/30 disabled:text-gray-400'
				: 'flex cursor-default items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset  ring-gray-300  hover:bg-gray-50'
			: overrideClass,
		rest.class,
		extraClass
	)}
>
	{#if icon}
		{@render icon?.()}
	{/if}
	{@render children?.()}
</button>
